module.exports = __webpack_public_path__ + "static/media/flag_en.05615112.svg";